/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Speed_Manual_TitleInputs */



/**
* | output |
* | --- |
* | "Manual speed" |
*
* @param {Audio_Recorder_Speed_Manual_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_speed_manual_title = /** @type {((inputs?: Audio_Recorder_Speed_Manual_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Speed_Manual_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse manuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuelle Geschwindigkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ручная скорость")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("手动挡")
	if (locale === "ja") return /** @type {LocalizedString} */ ("手動速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनुअल गति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Velocidade manual")
	return /** @type {LocalizedString} */ ("Manual speed")
});